import { createRouter, createWebHashHistory } from 'vue-router'

/** 视图定义：路由、标题、图标集中在此，侧栏与底部导航共用同一份。 */
export const NAV_ITEMS = [
  { path: '/', name: 'dashboard', title: '总览', short: '总览', icon: 'gauge-high' },
  { path: '/positions', name: 'positions', title: '持仓', short: '持仓', icon: 'layer-group' },
  // 平仓是唯一会真正发出订单的页面，单独成路由：
  // 混在持仓监控页里，浏览和下单只隔一次滚动，太容易顺手点到。
  { path: '/closeout', name: 'closeout', title: '平仓', short: '平仓', icon: 'arrow-trend-down' },
  { path: '/plan', name: 'plan', title: '盘前计划', short: '计划', icon: 'clipboard-check' },
  { path: '/calc', name: 'calc', title: '净收益测算', short: '测算', icon: 'calculator' },
  { path: '/risk', name: 'risk', title: '风险控制', short: '风控', icon: 'shield-halved' },
  { path: '/orders', name: 'orders', title: '订单', short: '订单', icon: 'list-check' },
  { path: '/system', name: 'system', title: '系统', short: '系统', icon: 'server' },
]

const routes = [
  { path: '/', component: () => import('@/views/DashboardView.vue') },
  { path: '/positions', component: () => import('@/views/PositionsView.vue') },
  { path: '/closeout', component: () => import('@/views/CloseoutView.vue') },
  { path: '/plan', component: () => import('@/views/PlanView.vue') },
  { path: '/calc', component: () => import('@/views/CalculatorView.vue') },
  { path: '/risk', component: () => import('@/views/RiskView.vue') },
  { path: '/orders', component: () => import('@/views/OrdersView.vue') },
  { path: '/system', component: () => import('@/views/SystemView.vue') },

  // 运维诊断：独立布局，不挂侧栏与顶栏，且**不在界面上提供任何入口**，
  // 只能手动输入 #/diagnostics 访问。
  //
  // 刻意不做入口：它是运维页面，不属于交易员的日常动线；
  // 改 API 地址这类操作放在随手可点的地方，误触的代价比找不到入口大。
  {
    path: '/diagnostics',
    component: () => import('@/views/DiagnosticsView.vue'),
    meta: { layout: 'blank' },
  },
]

// 用 hash 路由：静态服务直接发文件，不需要为 history 模式配 fallback
export default createRouter({
  history: createWebHashHistory(),
  routes,
})
